import { FC, useMemo } from 'react';

import { classNames } from '@/utils/classNames';

import usePlankDragSource from '../../hooks/usePlankDragSource';
import usePlankTableStore from '../../hooks/usePlankTableStore';
import { Reserve } from '../../types';
import { reserveToSelectionItem } from '../../utils/plankSelectionItems';
import NotitieRelatedItem from '../Notitie/NotitieRelatedItem';
import SidepanelToggle from '../Sidepanel/Toggle/SidepanelToggle';

import ReserveDefectIcon from './ReserveDefectIcon';
import ReserveToelichting from './ReserveToelichting';

import plankStyles from '../../PlankView.module.css';
import tableStyles from '../Table/Table.module.css';
import styles from './Reserve.module.css';

const ReserveListItem: FC<{ reserve: Reserve }> = ({ reserve }) => {
  const relatedDefect = usePlankTableStore((state) => state.getRelatedDefect(String(reserve.eenheid)));
  const relatedNotitie = usePlankTableStore((state) => state.getReserveNotitie(reserve));
  const itemClass = reserve.buitenDienstTijd ? tableStyles.cardStyleXl : tableStyles.cardStyleSm;
  const selectionItem = useMemo(() => reserveToSelectionItem(reserve), [reserve]);

  // Whether this row is currently open in the sidepanel (shown with a focus border). The drag
  // cursor should also appear here, not only on a Ctrl/Shift multi-selection.
  const isFocused = usePlankTableStore((state) => state.isEenheidSelected({ eenheid: reserve.eenheid, reserve }));

  const { isSelected, showDragCursor, dragProps, onSelectionClickCapture } = usePlankDragSource({
    item: selectionItem,
    testId: `draggableReserve_${reserve.id}`,
    isFocused,
  });

  return (
    <SidepanelToggle
      eenheid={reserve.eenheid}
      reserve={reserve}
      notitie={relatedNotitie}
      onClickCapture={onSelectionClickCapture}
    >
      <div
        className={classNames(
          itemClass,
          isSelected && tableStyles.plankSelectedStyle,
          showDragCursor && tableStyles.plankDraggableStyle,
        )}
        {...dragProps}
      >
        <div className={styles.reserveItemStyle} style={{ height: reserve.buitenDienstTijd ? '58px' : '32px' }}>
          <div className={styles.tableListItemRowStyle}>
            <div className={styles.tableListItemStyle}>
              <div className={plankStyles.eenheidStyle}>{reserve.eenheid}</div>
              <ReserveDefectIcon reserve={reserve} relatedDefect={relatedDefect} />
              <div className={plankStyles.drglpStyle}>{reserve.dienstregelpunt.toLocaleLowerCase()}</div>
            </div>
            <NotitieRelatedItem notitie={relatedNotitie} />
          </div>
          <ReserveToelichting reserve={reserve} />
        </div>
      </div>
    </SidepanelToggle>
  );
};
export default ReserveListItem;
